// --- smooth scroll --------------


// const lenis = new Lenis({
//   smoothWheel: true, // Smooth wheel behavior
//   smoothTouch: false, // Disable smooth touch scrolling (if needed)
//   normalizeWheel: true, // Normalize wheel events
//   // Ignore elements with the class 'scroll-section' (or any other class you use)
//   ignore: (el) => el.classList.contains("scroll-section"),
// });

// lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  // lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------

// --------- header clock -------------

function updateIndianTime() {
  const options = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const indianTime = new Date().toLocaleTimeString("en-IN", options);
  const timeElements = document.getElementsByClassName("ind-time");

  Array.from(timeElements).forEach((element) => {
    element.innerHTML = `INDIA &nbsp;&nbsp;&nbsp; ${indianTime}`;
  });
}
updateIndianTime();
setInterval(updateIndianTime, 1000);
// --------- header clock -------------

//---------------- Header cart total update--------------------------
// Select the element that displays the cart total
function formatINR(amount) {
  return new Intl.NumberFormat("en-IN", {
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(amount / 100);
}
let lastCartTotal = null;
document.addEventListener("DOMContentLoaded", () => {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    if (
      args[0].includes("/add") ||
      args[0].includes("/change") ||
      args[0].includes("/update")
    ) {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          if (cart.total_price !== lastCartTotal) {
            lastCartTotal = cart.total_price;
            document.querySelector(
              ".header-cart-total"
            ).innerText = `RS. ${formatINR(lastCartTotal)}`;
          }
        });
    }

    return response;
  };
});
//---------------- Header cart total update END--------------------------

// ================= Menu Drawer ===================

const menuBtn = document.querySelector(".top-right-four .m-menu");
const menuCont = document.querySelector(".menu-cont");

menuBtn.addEventListener("click", () => {
  menuCont.classList.toggle("active");
});

function closeMenu() {
  menuCont.classList.remove("active");
}
//edited by Nikita//
const menu = document.querySelector('.menu-cont');

function syncScrollLock() {
  document.body.classList.toggle('no-scroll', menu?.classList.contains('active'));
}

syncScrollLock();
new MutationObserver(syncScrollLock).observe(menu, { attributes: true, attributeFilter: ['class'] });
//edited by Nikita//

// ================= Menu Drawer ===================

// --------------------Draggable Scroll --------------------------------

function initDragToScroll(container) {
  if (!container) return;
  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;
  let currentX = 0;
  let rafId = null;
  let hasDragged = false;
  const dragThreshold = 5;

  // Prevent images from being dragged
  container.querySelectorAll("img").forEach((img) => {
    img.setAttribute("draggable", "false");
  });

  // Disable or enable anchor interactions and text selection
  const toggleAnchors = (disable) => {
    container.querySelectorAll("a").forEach((anchor) => {
      anchor.style.pointerEvents = disable ? "none" : "";
      anchor.style.userSelect = disable ? "none" : "";
    });
  };

  // Toggle text selection on the container itself
  const toggleContainerSelection = (disable) => {
    container.style.userSelect = disable ? "none" : "";
  };

  // Smoothly update scroll position while dragging
  const smoothScroll = () => {
    if (!isDragging) return;

    const distance = currentX - startX;

    if (Math.abs(distance) > dragThreshold && !hasDragged) {
      hasDragged = true;
      toggleAnchors(true);
      toggleContainerSelection(true);
    }

    container.scrollLeft = scrollLeft - distance;
    rafId = requestAnimationFrame(smoothScroll);
  };

  const startDragging = (e) => {
        const target = e.target;
        if (target.closest("input, textarea, select, button ,.confirm-btn,p,h1,h2,span")) return; // Skip form elements
    isDragging = true;
    hasDragged = false;
    startX = e.pageX;
    currentX = startX;
    scrollLeft = container.scrollLeft;

    e.preventDefault(); // Prevent text selection
    container.classList.add("dragging");

    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(smoothScroll);
  };

  const stopDragging = () => {
    isDragging = false;
    container.classList.remove("dragging");
    cancelAnimationFrame(rafId);

    // Re-enable interactions after drag ends
    setTimeout(() => {
      toggleAnchors(false);
      toggleContainerSelection(false);
      hasDragged = false;
    }, 0);
  };

  // Event listeners
  container.addEventListener("mousedown", startDragging);
  container.addEventListener("mousemove", (e) => {
    if (isDragging) {
      currentX = e.pageX;
    }
  });
  container.addEventListener("mouseup", stopDragging);
  container.addEventListener("mouseleave", stopDragging);

  // Prevent link clicks if dragged
  container.addEventListener("click", (e) => {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
}

// Initialize drag-to-scroll on all sliders
document.addEventListener("DOMContentLoaded", () => {
  // Custome Scroll
  // initDragToScroll(document.querySelector('.sect6-flex-container'));
  // initDragToScroll(document.querySelector('product__media-list'));

  // Shopify Product Scroll Use This
  const sliders = document.querySelectorAll(".grid");
  sliders.forEach((slider) => initDragToScroll(slider));
});

// --------------------Draggable Scroll --------------------------------

// --------------------Footer Accordian --------------------------------

// // // // // // Edited BY Nikita // // // // // // 
(function() {
  const initializeAccordion = () => {
    const accordionHeaders = document.querySelectorAll('.f-navlist p');

    // Restore open submenu index from sessionStorage
    const openIndex = sessionStorage.getItem('openFooterSubmenu');
    if (openIndex !== null && accordionHeaders[openIndex]) {
      accordionHeaders[openIndex].classList.add('active');
      const content = accordionHeaders[openIndex].nextElementSibling;
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }

    accordionHeaders.forEach((header, index) => {
      header.removeEventListener('click', toggleAccordion);
      header.addEventListener('click', (event) => toggleAccordion(event, index));
    });
  };

  const toggleAccordion = (event, index) => {
    const clickedHeader = event.currentTarget;
    const accordionHeaders = document.querySelectorAll('.f-navlist p');
    const activeHeader = document.querySelector('.f-navlist p.active');

    // Close previously active, if it's not the clicked one
    if (activeHeader && activeHeader !== clickedHeader) {
      activeHeader.classList.remove('active');
      if (activeHeader.nextElementSibling) {
        activeHeader.nextElementSibling.style.maxHeight = 0;
      }
    }

    // Toggle clicked header
    clickedHeader.classList.toggle('active');
    const content = clickedHeader.nextElementSibling;

    if (content) {
      if (clickedHeader.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        // Save index in sessionStorage
        sessionStorage.setItem('openFooterSubmenu', index);
      } else {
        content.style.maxHeight = 0;
        // Remove from sessionStorage if closing
        sessionStorage.removeItem('openFooterSubmenu');
      }
    }
  };

  initializeAccordion();
})();

////Home Hero Section Javascript/////
  window.addEventListener('load', function () {
    const leftContent = document.querySelector('.left-content');
    const imageContent = document.querySelector('.image-content');
    const rightContent = document.querySelector('.right-content');
    const mobileImage = document.querySelector('.mobile-img');

    if (!leftContent || !imageContent || !rightContent || !mobileImage) return;

    function applyParallax() {
      const y = window.scrollY;
      leftContent.style.transform = `translateY(${y * -0.3}px)`;
      imageContent.style.transform = `translateY(${y * -0.3}px)`;
      rightContent.style.transform = `translateY(${y * -0.3}px)`;
      mobileImage.style.transform = `translateY(${y * -0.3}px)`;
    }

    window.addEventListener('scroll', applyParallax);
  });
////Home Hero Section Javascript/////


////Vertical Carousel//////
  const sections = Array.from(document.querySelectorAll('.ron-stack'));
  const texts    = Array.from(document.querySelectorAll('.ron-section-text'));

  // pick the section that crosses the viewport center
  function updateActive() {
    const centerY = window.innerHeight / 2;
    let activeIndex = -1;

    sections.forEach((section, i) => {
      const r = section.getBoundingClientRect();
      const hitsCenter = r.top <= centerY && r.bottom >= centerY;
      if (hitsCenter) activeIndex = i;
    });

    texts.forEach((t, i) => t.classList.toggle('active', i === activeIndex));
  }

  // run once and on scroll/resize (throttled with rAF)
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateActive();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', updateActive);
  updateActive();
////Vertical Carousel//////

/////// ND Accordion – PDP + Quick Add ///////
(function () {
  const openItem = (item) => {
    const panel = item.querySelector(".nd-panel");
    const trigger = item.querySelector(".nd-trigger");
    if (!panel || !trigger) return;

    panel.style.maxHeight = panel.scrollHeight + "px";
    trigger.style.color = "black";
    item.classList.add("active");

    const onEnd = (e) => {
      if (e.propertyName === "max-height") {
        panel.style.maxHeight = "none";
        // panel.style.margin-bottom: 1%;
        panel.removeEventListener("transitionend", onEnd);
      }
    };
    panel.addEventListener("transitionend", onEnd);
  };

  const closeItem = (item) => {
    const panel = item.querySelector(".nd-panel");
    const trigger = item.querySelector(".nd-trigger");
    if (!panel || !trigger) return;

    if (panel.style.maxHeight === "" || panel.style.maxHeight === "none") {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.getBoundingClientRect(); // force reflow
    }

    panel.style.maxHeight = "0px";
    trigger.style.color = "#555";
    item.classList.remove("active");
  };

  document.addEventListener("DOMContentLoaded", () => {
    const accordions = document.querySelectorAll(".nd-accordion");
    accordions.forEach((accordion) => {
      const firstItem = accordion.querySelector(".nd-item");
      if (firstItem) openItem(firstItem);
    });
  });

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".nd-trigger");
    if (!trigger) return;

    const item = trigger.closest(".nd-item");
    if (!item) return;

    const accordion = item.closest(".nd-accordion") || document;
    const currentActive = accordion.querySelector(".nd-item.active");
    const isSame = currentActive === item;

    if (currentActive && !isSame) {
      closeItem(currentActive);
    }

    if (!isSame) {
      const panel = item.querySelector(".nd-panel");
      if (panel) panel.style.maxHeight = "0px";
      requestAnimationFrame(() => openItem(item));
    } else {
      // Clicking the open one closes it
      closeItem(item);
    }
  });
})();
/////// ND Accordion ///////
document.addEventListener("DOMContentLoaded", function () {
  const trustIcons = document.querySelectorAll(".trust-icon");

  trustIcons.forEach(function (icon) {
    const btn = icon.querySelector(".trust-info-btn");
    const tooltip = icon.querySelector(".trust-tooltip");

    if (!btn || !tooltip) return;

    // Click on "i" → toggle this tooltip
    btn.addEventListener("click", function (e) {
      e.stopPropagation();

      // Close all other open tooltips
      document.querySelectorAll(".trust-tooltip.is-open").forEach(function (tt) {
        if (tt !== tooltip) tt.classList.remove("is-open");
      });

      // Toggle the current one
      tooltip.classList.toggle("is-open");
    });
  });

  // Close all tooltips when clicking outside
  document.addEventListener("click", function () {
    document.querySelectorAll(".trust-tooltip.is-open").forEach(function (tt) {
      tt.classList.remove("is-open");
    });
  });
});

// product accordion start
(function () {
  if (!matchMedia("(max-width: 950px)").matches) return;

  const THRESH = 35;
  const DUR = 260;
  const ease = (t) => 1 - Math.pow(1 - t, 3);

  function animate(el, to) {
    const from = el.scrollLeft;
    const diff = to - from;
    if (!diff) return;

    const start = performance.now();
    if (el.__raf) cancelAnimationFrame(el.__raf);

    const tick = (now) => {
      const t = Math.min(1, (now - start) / DUR);
      el.scrollLeft = from + diff * ease(t);
      if (t < 1) el.__raf = requestAnimationFrame(tick);
    };

    el.__raf = requestAnimationFrame(tick);
  }

  document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach((cmp) => {
    const track = cmp.querySelector('ul[id^="Slider-Gallery-"]');
    if (!track) return;

    // hard-disable native snapping & smooth
    track.style.scrollSnapType = "none";
    track.style.scrollBehavior = "auto";

    const slides = () => [...track.querySelectorAll("li.slider__slide")];

    const nearest = () => {
      const s = slides();
      if (!s.length) return 0;
      const left = track.scrollLeft;
      let best = 0, min = Infinity;
      for (let i = 0; i < s.length; i++) {
        const d = Math.abs(s[i].offsetLeft - left);
        if (d < min) { min = d; best = i; }
      }
      return best;
    };

      const go = (i) => {
      const s = slides();
      if (!s.length) return;
      if (i < 0) i = s.length - 1;
      if (i >= s.length) i = 0;
      animate(track, s[i].offsetLeft);
      };

    // touch = 1 step
    let startX = 0, startI = 0, dragging = false;

    track.addEventListener("touchstart", (e) => {
      const t = e.touches && e.touches[0];
      if (!t) return;
      dragging = true;
      startX = t.clientX;
      startI = nearest();
    }, { passive: true });

    track.addEventListener("touchend", (e) => {
      if (!dragging) return;
      dragging = false;

      const x = (e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientX) || startX;
      const dx = x - startX;

      if (Math.abs(dx) < THRESH) return go(startI);
      go(dx < 0 ? startI + 1 : startI - 1);
    }, { passive: true });

    // wheel/trackpad = 1 step per gesture
    let lock = false, acc = 0, resetT = null;

    track.addEventListener("wheel", (e) => {
      if (dragging) return;
      e.preventDefault();

      const d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      acc += d;

      clearTimeout(resetT);
      resetT = setTimeout(() => (acc = 0), 120);

      if (lock || Math.abs(acc) < 35) return;
      lock = true;

      go(nearest() + (acc > 0 ? 1 : -1));

      setTimeout(() => { lock = false; acc = 0; }, 420);
    }, { passive: false });
  });
})();
// product accordion end
//filter No Scroll///
function syncFilterScrollLock() {
  const anyFacetOpen = document.querySelector('.mobile-facets__disclosure[open]');
  document.body.classList.toggle('no-scroll', !!anyFacetOpen);
}
syncFilterScrollLock();
document.addEventListener('toggle', (e) => {
  if (e.target && e.target.matches('.mobile-facets__disclosure')) {
    syncFilterScrollLock();
  }
}, true);
//filter No Scroll///

// // // // // // Edited BY Nikita // // // // // // 
// accordion code start

//      (function() {
//     const initializeAccordion = () => {
//         const accordionItemHeaders = document.querySelectorAll(".f-navlist p");
//         accordionItemHeaders.forEach(header => {
//             header.removeEventListener("click", toggleAccordion);
//         });

//         accordionItemHeaders.forEach((accordionItemHeader) => {
//             accordionItemHeader.addEventListener("click", toggleAccordion);
//         });
//       // Edited by nikita
//       // Open the first accordion by default
//         const firstHeader = accordionItemHeaders[1];
//         if (firstHeader) {
//             firstHeader.classList.add("active");
//             const firstBody = firstHeader.nextElementSibling;
//             if (firstBody) {
//                 firstBody.style.maxHeight = firstBody.scrollHeight + "px";
//             }
//         }
//     };

//     const toggleAccordion = (event) => {
//         const accordionItemHeader = event.currentTarget;
//         const currentlyActiveAccordionItemHeader = document.querySelector(".f-navlist p.active");

//         if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
//             currentlyActiveAccordionItemHeader.classList.remove("active");
//             currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
//         }
//         accordionItemHeader.classList.toggle("active");
//         const accordionItemBody = accordionItemHeader.nextElementSibling;
//         if (accordionItemHeader.classList.contains("active")) {
//             accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
//         } else {
//             accordionItemBody.style.maxHeight = 0;
//         }
//     };
//     initializeAccordion();
// })();

// accordion code end

// accordion code end

// --------------------Footer Accordian --------------------------------

// --------------------Menu Accordian --------------------------------


// product accordion start
(function() {
    const initializeAccordion = () => {
        const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

        // Remove previous event listeners to prevent stacking
        accordionItemHeaders.forEach(header => {
            header.removeEventListener("click", toggleAccordion);
        });

        if (accordionItemHeaders.length > 0) {
            accordionItemHeaders.forEach((accordionItemHeader) => {
                accordionItemHeader.addEventListener("click", toggleAccordion);
            });

      // Edited by nikita
      // Open the third accordion by default
            // const defaultIndex = 2; // 0-based index → 3rd item
            // if (accordionItemHeaders[defaultIndex]) {
            //     accordionItemHeaders[defaultIndex].classList.add("active");
            //     const accordionItemBody = accordionItemHeaders[defaultIndex].nextElementSibling;
            //     accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
            // }
        }
    };

    const toggleAccordion = (event) => {
        const accordionItemHeader = event.currentTarget;
        const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");

        if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
            currentlyActiveAccordionItemHeader.classList.remove("active");
            currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }

        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
            accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px"; // Set max-height to scroll height
        } else {
            accordionItemBody.style.maxHeight = 0;
        }
    };

    // Call the function to initialize the accordion
    initializeAccordion();
})();


// --------------------Menu Accordian --------------------------------
////UGC gallery///
(() => {
  const wrapper = document.querySelector('.ugc-image-wrapper');
  const list = document.querySelector('.ugc-image-list');
  const nextBtn = document.querySelector('.ugc-carousel-next');
  const prevBtn = document.querySelector('.ugc-carousel-prev');

  const modal = document.getElementById('ugcModal');
  const imgEl = document.getElementById('ugcModalImg');
  const vidEl = document.getElementById('ugcModalVideo');

  const titleEl = document.getElementById('ugcModalTitle');
  const descEl = document.getElementById('ugcModalDesc');
  const priceEl = document.getElementById('ugcModalPrice');
  const linkEl = document.getElementById('ugcModalLink');
  const ctaEl  = document.getElementById('ugcModalCta');

  if (!wrapper || !list || !modal || !imgEl || !vidEl) return;

  const getStep = () => {
    const first = list.querySelector('.ugc-item');
    if (!first) return wrapper.clientWidth * 0.8;
    const gap = parseFloat(getComputedStyle(list).gap || 0);
    return first.getBoundingClientRect().width + gap;
  };

  const openModal = (btn) => {
    const url   = btn.dataset.url || '#';
    const title = btn.dataset.title || '';
    const desc  = btn.dataset.desc || '';
    const price = btn.dataset.price || '';
    const img   = btn.dataset.img || '';
    const video = btn.dataset.video || '';

    titleEl.textContent = title;
    descEl.textContent  = desc;
    priceEl.innerHTML = price;
    linkEl.href = url;
    ctaEl.href  = url;

    // ✅ VIDEO MODE
    if (video) {
      imgEl.hidden = true;
      imgEl.src = '';
      imgEl.alt = '';

      vidEl.hidden = false;
      vidEl.src = video;
      vidEl.currentTime = 0;
      vidEl.play().catch(() => {});
    }
    // ✅ IMAGE MODE
    else {
      vidEl.pause();
      vidEl.hidden = true;
      vidEl.removeAttribute('src');
      vidEl.load();

      imgEl.hidden = false;
      imgEl.alt = title;
      imgEl.src = img;
    }

    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ugc-lock');
  };

  const closeModal = () => {
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ugc-lock');

    imgEl.src = '';

    vidEl.pause();
    vidEl.hidden = true;
    vidEl.removeAttribute('src');
    vidEl.load();
  };

  // ---- arrows ----
  nextBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    wrapper.scrollBy({ left: getStep(), behavior: 'smooth' });
  });
  prevBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    wrapper.scrollBy({ left: -getStep(), behavior: 'smooth' });
  });

  // ---- drag (keeps click-to-open working) ----
  let down = false, didDrag = false;
  let startX = 0, startScroll = 0;

  wrapper.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    down = true;
    didDrag = false;
    startX = e.clientX;
    startScroll = wrapper.scrollLeft;
    wrapper.classList.add('is-dragging');
  });

  wrapper.addEventListener('pointermove', (e) => {
    if (!down) return;
    const dx = e.clientX - startX;
    if (!didDrag && Math.abs(dx) > 8) didDrag = true;
    if (!didDrag) return;
    e.preventDefault();
    wrapper.scrollLeft = startScroll - dx;
  }, { passive: false });

  const stop = () => {
    down = false;
    wrapper.classList.remove('is-dragging');
  };
  wrapper.addEventListener('pointerup', stop);
  wrapper.addEventListener('pointercancel', stop);
  wrapper.addEventListener('dragstart', (e) => e.preventDefault());

  // ---- delegated clicks ----
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-ugc-close]')) {
      closeModal();
      return;
    }

    const card = e.target.closest('.ugc-card');
    if (card) {
      if (didDrag) {
        e.preventDefault();
        didDrag = false;
        return;
      }
      openModal(card);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
  });
})();

// ND Collection SubTitle
(function () {
    const subtitle = document.getElementById('collectionSubtitle');
    const btn = document.getElementById('readMoreBtn');

    window.toggleSubtitle = function () {
      if (subtitle.classList.contains('collapsed')) {
        subtitle.classList.remove('collapsed');
        subtitle.classList.add('expanded');
        btn.textContent = 'read less';
      } else {
        subtitle.classList.remove('expanded');
        subtitle.classList.add('collapsed');
        btn.textContent = 'read more';
      }
    };
  })();
// ND Collection SubTitle
// ND Product Model//
(() => {
  const MQ = "(max-width: 950px)";
  const THRESH = 30;
  const DUR = 110;
  const SNAP_DELAY = 50;

  // Easing function
  const ease = (t) => 1 - Math.pow(1 - t, 3);

  // Smooth scroll animation using RAF
  const animateScrollLeft = (el, to) => {
    const diff = to - el.scrollLeft;
    if (!diff) return;
    const start = performance.now();
    if (el.__ndRAF) cancelAnimationFrame(el.__ndRAF);
    const tick = (now) => {
      const t = Math.min(1, (now - start) / DUR);
      el.scrollLeft += diff * ease(t) - (el.scrollLeft - (to - diff));
      if (t < 1) el.__ndRAF = requestAnimationFrame(tick);
      else el.scrollLeft = to;
    };
    el.__ndRAF = requestAnimationFrame(tick);
  };

  const initModal = (modal) => {
    const track = modal.querySelector("ul.nd-modal-slider");
    if (!track || track.__ndInit) return;
    track.__ndInit = true;

    track.style.cssText += "scroll-snap-type:none;scroll-behavior:auto;";

    const getSlides = () => [...track.querySelectorAll("li.nd-modal-slide")];

    const nearestIndex = () => {
      const slides = getSlides();
      const left = track.scrollLeft;
      return slides.reduce((best, s, i) => {
        return Math.abs(s.offsetLeft - left) < Math.abs(slides[best].offsetLeft - left) ? i : best;
      }, 0);
    };

    const go = (i, animate = true) => {
      const slides = getSlides();
      if (!slides.length) return;
       if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      const to = slides[i].offsetLeft;

      animate ? animateScrollLeft(track, to) : (track.scrollLeft = to);

      // Update counter
      const cur = modal.querySelector(".slider-counter--current");
      const tot = modal.querySelector(".slider-counter--total");
      if (cur) cur.textContent = i + 1;
      if (tot) tot.textContent = slides.length;

      // Update thumbs
      modal.querySelectorAll(".nd-modal-thumb").forEach((b) => {
        const active = b.getAttribute("data-target") === slides[i].id;
        b.classList.toggle("is-active", active);
        b.style.opacity = active ? "1" : "0.55";
      });
    };

    go(nearestIndex(), false);

    // Jump to correct slide when modal opens via data-media-id
new MutationObserver(() => {
  if (!modal.hasAttribute('open')) return;

  // Find the trigger button that opened this modal
  const mediaId = modal.__pendingMediaId;
  if (!mediaId) return;

  const slides = getSlides();
  const target = modal.querySelector(`#ndModalSlide-${mediaId}`);
  if (!target) return;

  const idx = slides.indexOf(target);
  if (idx >= 0) go(idx, false);

  modal.__pendingMediaId = null;
}).observe(modal, { attributes: true, attributeFilter: ['open'] });

    // Single delegated click handler for arrows + thumbs
    modal.addEventListener("click", (e) => {
      if (e.target.closest(".nd-modal-arrows .slider-button--next")) {
        e.preventDefault();
        return go(nearestIndex() + 1);
      }
      if (e.target.closest(".nd-modal-arrows .slider-button--prev")) {
        e.preventDefault();
        return go(nearestIndex() - 1);
      }
      const thumb = e.target.closest(".nd-modal-thumb");
      if (thumb) {
        const slide = document.getElementById(thumb.getAttribute("data-target"));
        if (slide) {
          const idx = getSlides().indexOf(slide);
          if (idx >= 0) go(idx);
        }
      }
    });

    // Touch swipe (mobile only)
    let startX = 0, startI = 0, dragging = false;
    track.addEventListener("touchstart", (e) => {
      if (!matchMedia(MQ).matches) return;
      dragging = true;
      startX = e.touches[0].clientX;
      startI = nearestIndex();
    }, { passive: true });

    track.addEventListener("touchend", (e) => {
      if (!matchMedia(MQ).matches || !dragging) return;
      dragging = false;
      const dx = (e.changedTouches[0]?.clientX ?? startX) - startX;
      go(Math.abs(dx) < THRESH ? startI : startI + (dx < 0 ? 1 : -1));
    }, { passive: true });

    // Snap after scroll momentum
    let snapT = null;
    track.addEventListener("scroll", () => {
      clearTimeout(snapT);
      snapT = setTimeout(() => go(nearestIndex()), SNAP_DELAY);
    }, { passive: true });

    // Keyboard navigation
    modal.addEventListener("keyup", (e) => {
      const map = {
        Home: () => go(0),
        End: () => go(getSlides().length - 1),
        ArrowLeft: () => go(nearestIndex() - 1),
        ArrowRight: () => go(nearestIndex() + 1),
      };
      if (map[e.key]) { e.preventDefault(); map[e.key](); }
    });

    window.addEventListener("resize", () => go(nearestIndex(), false));
    const lockScroll = () => document.body.classList.add('no-scroll');
    const unlockScroll = () => document.body.classList.remove('no-scroll');

    new MutationObserver(() => {
    modal.hasAttribute('open') ? lockScroll() : unlockScroll();
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    if (modal.hasAttribute('open')) lockScroll();
    } ;

  const initAll = () => {
    document.querySelectorAll("product-modal[id^='ProductModal-']").forEach(initModal);
  };

  initAll();
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });

  // Custom close button — capture phase beats Dawn's handler
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".nd-close-btn")) return;
    const modal = e.target.closest("product-modal");
    if (modal) modal.removeAttribute("open");
  }, true);

  // Capture which media was clicked before modal opens
document.addEventListener("click", (e) => {
  const trigger = e.target.closest("[data-media-id]");
  if (!trigger) return;

  const mediaId = trigger.dataset.mediaId;
  // Find the modal on the same page
  const modal = document.querySelector("product-modal[id^='ProductModal-']");
  if (modal) modal.__pendingMediaId = mediaId;
}, true);

})();

// B2B Custom Page //

  (() => {
    const init = () => {
      const root = document.getElementById('tee-bulk');
      if (!root || root.dataset.initialized) return;
      root.dataset.initialized = 'true';

      /* =========================
       DATA
    ========================= */

      const products = {
        round_compact: {
          short: 'Regular Fit Round Neck T-shirt (100% Compact Cotton Bio Washed | GSM: 180)',
          name: 'Regular Fit Round Neck T-shirt (100% Compact Cotton Bio Washed | GSM: 180)',
          category: 'tshirt',
          cost: 167,
          methods: {
            dtg_color: [1, 100],
            dtg_white: [0.8, 50],
            heat_transfer: [0.6, 35],
            heat_specialty: [1.2, 35],
            flat_embroidery: [2.9, 200],
            '3d_embroidery': [5.6, 200],
          },
        },
        round_supima: {
        short: 'Regular Fit Round Neck T-Shirt (100% Supima Cotton | GSM: 180 | Color: Black)',
        name: 'Regular Fit Round Neck T-Shirt (100% Supima Cotton | GSM: 180 | Color: Black)',
        category: 'tshirt',
        cost: 345,
        methods: {
        heat_transfer: [0.6, 35],
        heat_specialty: [1.2, 35],
        flat_embroidery: [2.9, 200],
        '3d_embroidery': [5.8, 200],
        },
      },

        oversized: {
          short: 'Oversized Fit T-shirt (Unisex | 14 Colors | 100% Cotton | GSM: 240)',
          name: 'Oversized Fit T-shirt (Unisex | 14 Colors | 100% Cotton | GSM: 240)',
          category: 'tshirt',
          cost: 253,
          methods: {
            dtg_color: [1, 100],
            dtg_white: [0.8, 50],
            heat_transfer: [0.6, 35],
            heat_specialty: [1.2, 35],
            flat_embroidery: [2.9, 200],
            '3d_embroidery': [5.8, 200],
          },
        },

        trucker_cap: {
          short: 'Trucker Cap',
          name: 'Trucker Cap',
          category: 'cap',
          cost: 397,
          methods: {
            heat_transfer: [0.6, 35],
            heat_specialty: [1.2, 35],
            flat_embroidery: [2.9, 200],
            '3d_embroidery': [5.6, 200],
          },
        },

        dad_cap: {
          short: 'Dad Cap',
          name: 'Dad Cap',
          category: 'cap',
          cost: 483,
          methods: {
            heat_transfer: [0.6, 35],
            heat_specialty: [1.2, 35],
            flat_embroidery: [2.9, 200],
            '3d_embroidery': [5.6, 200],
          },
        },

        denim_cap: {
          short: 'Denim Cap',
          name: 'Denim Cap',
          category: 'cap',
          cost: 397,
          methods: {
            heat_transfer: [0.6, 35],
            heat_specialty: [1.2, 35],
            flat_embroidery: [2.9, 200],
            '3d_embroidery': [5.6, 200],
          },
        },

        suede_cap: {
          short: 'Suede Cap',
          name: 'Suede Baseball Cap - Structured Cap',
          category: 'cap',
          cost: 506,
          methods: {
            heat_transfer: [0.6, 35],
            heat_specialty: [1.2, 35],
            flat_embroidery: [2.9, 200],
            '3d_embroidery': [5.6, 200],
          },
        },
      };

      const methodNames = {
        dtg_color: 'DTG Printing: Color Garment',
        dtg_white: 'DTG Printing: White Garment',
        heat_transfer: 'Heat Transfer (HD / PU Vinyl)',
        heat_specialty: 'Specialty Heat Transfer (Flock / Puff / etc.)',
        flat_embroidery: 'Flat Embroidery',
        '3d_embroidery': '3D Embroidery',
      };

      /* =========================
       DOM
    ========================= */

      const $ = (s) => root.querySelector(s);
      const $$ = (s) => [...root.querySelectorAll(s)];

      const product = $('#teeProductSelect');
      const method = $('#teeDecorationMethod');
      const placements = $('#teePlacements');
      const quantity = $('#teeQuantity');
      const sample = $('#teeSample');
      const addPlacement = $('#teeAddPlacement');

      const calculator = $('#tee-calculator');
      const enquiry = $('#tee-enquiry');

      const mobileBar = $('#teeMobileQuote');
      const drawer = $('#teeQuoteDrawer');
      const drawerOpen = $('#teeOpenQuoteDrawer');

      const requirement = $('#teeProductRequirement');
      const quoteInput = $('#teeQuoteSummaryInput');
      const bases = $('.tee-base-options');

      if (!product || !method || !placements || !quantity || !sample) return;

      const estimate = {
        product: $$('[data-estimate-product]'),
        config: $$('[data-estimate-config]'),
        quantity: $$('[data-estimate-quantity]'),
        unit: $$('[data-estimate-unit]'),
        discountPercent: $$('[data-estimate-discount-percent]'),
        discount: $$('[data-estimate-discount]'),
        bulk: $$('[data-estimate-bulk]'),
        sample: $$('[data-estimate-sample]'),
        total: $$('[data-estimate-total]'),
        discountRows: $$('[data-estimate-discount-row]'),
        sampleRows: $$('[data-estimate-sample-row]'),
      };

      let selectedProduct = 'round_compact';
      let placementId = 0;
      let quote = null;
      let scrollRAF = 0;

      /* =========================
       HELPERS
    ========================= */

      const money = (n) =>
        '₹' +
        (+n || 0).toLocaleString('en-IN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

      const setText = (nodes, value) => nodes.forEach((node) => (node.textContent = value));

      const setHTML = (nodes, value) => nodes.forEach((node) => (node.innerHTML = value));

      const smoothScroll = (el) => {
        if (!el) return;

        el.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      };

      /* =========================
       PRODUCTS
    ========================= */

      const getProductKeys = (base) => {
        const keys = Object.keys(products);

        if (base === 'T-shirts') return keys.filter((key) => products[key].category === 'tshirt');

        if (base === 'Caps') return keys.filter((key) => products[key].category === 'cap');

        return keys;
      };

      function renderProducts(base = '', placeholder = false) {
        const keys = getProductKeys(base);

        product.innerHTML =
          (placeholder ? '<option value="" selected disabled>Select product</option>' : '') +
          keys.map((key) => `<option value="${key}">${products[key].short}</option>`).join('');

        if (placeholder) {
          selectedProduct = '';
          clearEstimate('Select a product');
          return;
        }

        if (!keys.includes(selectedProduct)) selectedProduct = keys[0] || '';

        product.value = selectedProduct;
      }

      function renderMethods(placeholder = false) {
        const p = products[selectedProduct];

        if (!p) {
          method.innerHTML = '<option value="" selected disabled>Select decoration method</option>';

          clearEstimate('Select a product');
          return;
        }

        const previous = method.value;

        method.innerHTML =
          (placeholder ? '<option value="" selected disabled>Select decoration method</option>' : '') +
          Object.keys(p.methods)
            .map((key) => `<option value="${key}">${methodNames[key]}</option>`)
            .join('');

        if (!placeholder && p.methods[previous]) method.value = previous;

        if (placeholder) clearEstimate('Select decoration method');
      }

      /* =========================
       PLACEMENTS
    ========================= */

      function renumberPlacements() {
        $$('.tee-placement-index').forEach((el, index) => {
          el.textContent = String(index + 1).padStart(2, '0');
        });
      }

      function addNewPlacement() {
        const removable = placements.children.length > 0;

        placements.insertAdjacentHTML(
          'beforeend',
          `
        <div class="tee-placement-row" data-id="${++placementId}">

          <div class="tee-placement-row__head">
            <strong>
              Placement <span class="tee-placement-index"></span>
            </strong>

            ${removable ? '<button type="button" class="tee-placement-remove">Remove</button>' : ''}
          </div>

          <div class="tee-field-grid tee-field-grid--four">

            <div class="tee-field">
              <label>Position</label>

              <select class="tee-placement-position">
                <option>Front</option>
                <option>Back</option>
                <option>Left Chest</option>
                <option>Right Chest</option>
                <option>Sleeve</option>
                <option>Other</option>
              </select>
            </div>

            <div class="tee-field">
              <label>Width</label>

              <input
                class="tee-placement-width"
                type="number"
                min="0"
                step=".01"
                inputmode="decimal"
                value="28"
              >
            </div>

            <div class="tee-field">
              <label>Height</label>

              <input
                class="tee-placement-height"
                type="number"
                min="0"
                step=".01"
                inputmode="decimal"
                value="36"
              >
            </div>

            <div class="tee-field">
              <label>Unit</label>

              <select class="tee-placement-unit">
                <option value="cm">cm</option>
                <option value="inch">inch</option>
              </select>
            </div>

          </div>
        </div>
      `
        );

        renumberPlacements();
        calculate();
      }

      /* =========================
       ESTIMATE
    ========================= */

      function clearEstimate(message = 'Select options') {
        quote = null;

        setText(estimate.product, message);
        setText(estimate.config, '');
        setText(estimate.quantity, '—');
        setText(estimate.unit, '—');
        setText(estimate.discountPercent, '0');
        setText(estimate.discount, '—');
        setText(estimate.bulk, '—');
        setText(estimate.sample, '—');
        setText(estimate.total, '₹0.00');

        estimate.discountRows.forEach((el) => (el.hidden = true));
        estimate.sampleRows.forEach((el) => (el.hidden = true));

        if (quoteInput) quoteInput.value = '';
      }

      function calculate() {
        const p = products[selectedProduct];

        if (!p || !method.value || !p.methods[method.value]) {
          clearEstimate(!p ? 'Select a product' : 'Select decoration method');
          return;
        }

        const [rate, minCharge] = p.methods[method.value];

        let processCharge = 0;
        const placementSummary = [];

        $$('.tee-placement-row').forEach((row) => {
          const width = Math.max(0, +row.querySelector('.tee-placement-width').value || 0);

          const height = Math.max(0, +row.querySelector('.tee-placement-height').value || 0);

          const unit = row.querySelector('.tee-placement-unit').value;

          const position = row.querySelector('.tee-placement-position').value;

          if (width && height) {
            const area = unit === 'cm' ? (width * height) / 6.4516 : width * height;

            processCharge += Math.max(area * rate, minCharge);
          }

          placementSummary.push(`${position} · ${width} × ${height} ${unit}`);
        });

        const qty = Math.max(1, parseInt(quantity.value, 10) || 1);

        const sampleRequired = sample.value === 'yes';

        const originalUnit = p.cost + processCharge;

        const discountPercent = qty >= 1000 ? 15 : qty >= 500 ? 10 : qty >= 100 ? 5 : 0;

        const discountPerUnit = (originalUnit * discountPercent) / 100;

        const unitPrice = originalUnit - discountPerUnit;

        const totalDiscount = discountPerUnit * qty;

        const bulk = unitPrice * qty;

        const sampleCharge = sampleRequired ? originalUnit * 4 : 0;

        quote = {
          product: p.name,
          short: p.short,
          method: methodNames[method.value],
          quantity: qty,
          placements: placementSummary,
          originalUnit,
          unit: unitPrice,
          discountPercent,
          totalDiscount,
          bulk,
          sample: sampleCharge,
          sampleRequired,
          total: bulk + sampleCharge,
        };

        renderEstimate();
      }

      function renderEstimate() {
        if (!quote) return;

        setText(estimate.product, quote.short);

        setText(estimate.config, `${quote.method} · ${quote.placements.join(' / ')}`);

        setText(estimate.quantity, `${quote.quantity} pcs`);

        setHTML(
          estimate.unit,
          quote.discountPercent
            ? `<span class="tee-estimate__old">${money(quote.originalUnit)}</span>${money(quote.unit)}`
            : money(quote.unit)
        );

        setText(estimate.discountPercent, quote.discountPercent);

        setText(estimate.discount, '-' + money(quote.totalDiscount));

        setText(estimate.bulk, money(quote.bulk));

        setText(estimate.sample, money(quote.sample));

        setText(estimate.total, money(quote.total));

        estimate.discountRows.forEach((el) => {
          el.hidden = !quote.discountPercent;
        });

        estimate.sampleRows.forEach((el) => {
          el.hidden = !quote.sampleRequired;
        });

        if (quoteInput) {
          quoteInput.value =
            `Product: ${quote.product} | ` +
            `Method: ${quote.method} | ` +
            `Quantity: ${quote.quantity} | ` +
            `Placements: ${quote.placements.join(', ')} | ` +
            `Estimated Total: ${money(quote.total)} | ` +
            `Exclusive of taxes and shipping`;
        }
      }

      /* =========================
       BASE SELECTION
    ========================= */

      function updateBase(value) {
        if (!bases) return;

        bases.querySelectorAll('.tee-base-option').forEach((card) => {
          const selected = card.dataset.baseValue === value;

          card.classList.toggle('is-selected', selected);
          card.setAttribute('aria-pressed', String(selected));

          const label = card.querySelector('.tee-base-check__text');

          if (label) label.textContent = selected ? 'SELECTED' : 'SELECT';
        });
      }

      function setRequirement(value) {
        if (!requirement) return;

        const exists = [...requirement.options].some((option) => option.value === value);

        if (exists) requirement.value = value;
      }

      function chooseBase(value) {
        updateBase(value);
        setRequirement(value);

        if (value === 'T-shirts') {
          selectedProduct = 'round_compact';

          renderProducts('T-shirts');
          renderMethods();
          calculate();
          smoothScroll(calculator);
          return;
        }

        if (value === 'Caps') {
          /*
          Deliberately no default cap.
          Customer must choose Trucker / Dad /
          Denim / Suede etc.
        */
          renderProducts('Caps', true);
          renderMethods(true);
          smoothScroll(calculator);
          return;
        }

        /*
        Mixed orders and custom requirements
        go directly to enquiry.
      */
        smoothScroll(enquiry);
      }

      /* =========================
       MOBILE BAR
    ========================= */

      function updateMobileBar() {
        if (!mobileBar || !calculator || !enquiry) return;

        if (window.innerWidth > 950) {
          mobileBar.classList.remove('is-visible');
          return;
        }

        const calcTop = calculator.getBoundingClientRect().top;

        const enquiryTop = enquiry.getBoundingClientRect().top;

        mobileBar.classList.toggle('is-visible', calcTop < window.innerHeight * 0.7 && enquiryTop > 70);
      }

      function scheduleMobileBar() {
        if (scrollRAF) return;

        scrollRAF = requestAnimationFrame(() => {
          updateMobileBar();
          scrollRAF = 0;
        });
      }

      /* =========================
       DRAWER
    ========================= */

      function toggleDrawer(open) {
        if (!drawer) return;

        if (open && window.innerWidth > 950) return;

        drawer.classList.toggle('is-open', open);

        drawer.setAttribute('aria-hidden', String(!open));

        document.body.classList.toggle('tee-quote-drawer-open', open);

        drawerOpen?.setAttribute('aria-expanded', String(open));
      }

      /* =========================
       EVENTS
    ========================= */

      product.addEventListener('change', () => {
        selectedProduct = product.value;

        /*
        User chose a product.
        Now decoration must be chosen explicitly.
      */
        renderMethods(true);
      });

      root.addEventListener('input', (event) => {
        if (event.target === quantity || event.target.matches('.tee-placement-width,.tee-placement-height')) {
          calculate();
        }
      });

      root.addEventListener('change', (event) => {
        if (
          event.target === method ||
          event.target === sample ||
          event.target.matches('.tee-placement-position,.tee-placement-unit')
        ) {
          calculate();
        }
      });

      addPlacement?.addEventListener('click', addNewPlacement);

      placements.addEventListener('click', (event) => {
        const button = event.target.closest('.tee-placement-remove');

        if (!button) return;

        button.closest('.tee-placement-row')?.remove();

        renumberPlacements();
        calculate();
      });

      bases?.addEventListener('click', (event) => {
        const card = event.target.closest('.tee-base-option');

        if (card) chooseBase(card.dataset.baseValue);
      });

      requirement?.addEventListener('change', () => {
        updateBase(requirement.value);
      });

      drawerOpen?.addEventListener('click', () => toggleDrawer(true));

      drawer?.addEventListener('click', (event) => {
        if (event.target.closest('[data-close-quote-drawer]') || event.target.closest('[data-drawer-quote-cta]')) {
          toggleDrawer(false);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer?.classList.contains('is-open')) {
          toggleDrawer(false);
        }
      });

      window.addEventListener('scroll', scheduleMobileBar, { passive: true });

      window.addEventListener(
        'resize',
        () => {
          scheduleMobileBar();

          if (window.innerWidth > 950 && drawer?.classList.contains('is-open')) {
            toggleDrawer(false);
          }
        },
        { passive: true }
      );

      /* =========================
       INIT
    ========================= */

      renderProducts();
      renderMethods();
      addNewPlacement();
      updateMobileBar();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  // 
  document.addEventListener('DOMContentLoaded', function () {
  const closeButtons = document.querySelectorAll('.nd-close-btn');

  closeButtons.forEach((button) => {
    button.addEventListener('click', function () {
      // Restore page scrolling when modal closes
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');
    });
  });
});